import { render, staticRenderFns } from "./TagPromocionV5.vue?vue&type=template&id=196e06b2&scoped=true"
import script from "./TagPromocionV5.vue?vue&type=script&lang=js"
export * from "./TagPromocionV5.vue?vue&type=script&lang=js"
import style0 from "./TagPromocionV5.vue?vue&type=style&index=0&id=196e06b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e06b2",
  null
  
)

export default component.exports